/**
 * coloringPages — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const coloringPagesPack: ToilePack = {
    slug: 'coloring-pages',
    category: 'coloring',
    name: 'Coloring pages',
    tagline: tagline('pages', 'subjects', 'difficulty levels'),
    chips: chips('subjects', 'levels'),
    ratio: A4,
    readings: [
        {key: 'dragon', label: 'Dragon', subject: 'a friendly dragon curled around a castle tower'},
        {key: 'unicorn', label: 'Unicorn', subject: 'a unicorn in a flower meadow, a rainbow behind'},
        {key: 'tractor', label: 'Tractor', subject: 'a farm tractor with a barn and hay bale'},
    ],
    styles: [
        {key: 'toddler', label: 'Toddler', style: 'toddler — few large shapes, thick outlines', palette: 'black line only', framing: 'full page, wide margin'},
        {key: 'kids', label: 'Kids', style: 'kids — clear medium detail', palette: 'black line only', framing: 'full page, white margin'},
        {key: 'intricate', label: 'Intricate', style: 'intricate — zentangle-style detail', palette: 'black line only', framing: 'full page, dense fill'},
    ],
    directions: ['a dinosaur instead', 'in a snowy winter scene', 'with a name banner'],
}
